import { Component, OnInit, Input } from '@angular/core';
import { AuctionQuery, AuctionItem, SignalRHub } from '@fgb/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { SortBarOption, SortOrder } from '@fgb/portal-component-library/src/lib/shared/sort-bar';
import { AuctionListSortOption } from './auction-list-sort-option.enum';

@Component({
  selector: 'fgbcl-auction-list',
  templateUrl: './auction-list.component.html',
  styleUrls: ['./auction-list.component.scss'],
})
export class AuctionListComponent implements OnInit {
  @Input() take: number | undefined;
  @Input() skip: number | undefined;
  @Input() isList: boolean;
  @Input() featuredIcon: string = 'star';
  @Input() defaultSort: AuctionListSortOption = AuctionListSortOption.TimeRemaining;
  auctions$: Observable<AuctionItem[]>;

  sortBarOptions: SortBarOption[];
  sortOrderType = SortOrder;
  sortedAuctions: AuctionItem[];

  private _destroyed$ = new Subject<void>();

  constructor(
    private auctionQuery: AuctionQuery,
    private signalRHub: SignalRHub
  ) {}

  ngOnInit() {
    this.subscribeAndSortAuctions();
    this.defineSortBarOptions();
    this.signalRHub.joinGroup('AuctionList').pipe(takeUntil(this._destroyed$)).subscribe();
  }

  ngOnDestroy() {
    this.signalRHub.removeFromGroup('AuctionList');
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  subscribeAndSortAuctions() {
    this.auctions$ = this.auctionQuery.selectAuctions().pipe(
      map((m) =>
        m.sort((a, b) => {
          switch (this.defaultSort) {
            case AuctionListSortOption.TimeRemaining:
              return this.sortByTimeRemaining(a, b);
            case AuctionListSortOption.Ordinal:
              return this.sortByOrdinal(a, b);
            default:
              return 0;
          }
        })
      ),
      tap((m: AuctionItem[]) => (this.sortedAuctions = m))
    );
  }

  defineSortBarOptions() {
    this.sortBarOptions = [
      {
        propertyToSort: 'CurrentValue',
        shouldToggle: true,
        order: this.sortOrderType.Descending,
        labelDESC: 'auction.highest.bid',
        labelASC: 'auction.lowest.bid',
      },
      {
        propertyToSort: 'EndDate',
        shouldToggle: false,
        order: this.sortOrderType.Ascending,
        labelASC: 'auction.ending.soon',
      },
      {
        propertyToSort: 'Id',
        shouldToggle: false,
        order: this.sortOrderType.Descending,
        labelDESC: 'auction.new',
      },
    ];
  }

  resetOrder() {
    this.subscribeAndSortAuctions();
  }

  private sortByTimeRemaining(a: AuctionItem, b: AuctionItem) {
    return a.TimeRemainingInSeconds - b.TimeRemainingInSeconds;
  }

  private sortByOrdinal(a: AuctionItem, b: AuctionItem) {
    return a.Ordinal - b.Ordinal;
  }
}
